import { getId } from "helpers/functions";
import {
  GET_CONTROL_REFERENCES,
  GET_CONTROL_REFERENCES_FAILURE,
  GET_CONTROL_REFERENCES_SUCCESS,
  ADD_CONTROL_REFERENCE,
  ADD_CONTROL_REFERENCE_SUCCESS,
  ADD_CONTROL_REFERENCE_FAILURE,
  DELETE_CONTROL_REFERENCE,
  DELETE_CONTROL_REFERENCE_SUCCESS,
  DELETE_CONTROL_REFERENCE_FAILURE,
  GET_SINGLE_CONTROL_REFERENCE,
  GET_SINGLE_CONTROL_REFERENCE_FAILURE,
  GET_SINGLE_CONTROL_REFERENCE_SUCCESS,
  SET_DEFAULT_CONTROL_REFERENCE_SUCCESS,
} from "./actionTypes";

const initialState = {
  controlReferences: [],
  loading: false,
  error: "",
  singleControlReference: {},
};

const stores = (state = initialState, action) => {
  switch (action.type) {
    case GET_CONTROL_REFERENCES:
      state = {
        ...state,
        loading: true,
      };
      break;
    case GET_CONTROL_REFERENCES_SUCCESS:
      state = {
        ...state,
        loading: false,
        controlReferences: action.payload.controlReferences,
      };
      break;
    case GET_CONTROL_REFERENCES_FAILURE:
      state = { ...state, error: action.payload, loading: false };
      break;

    case GET_SINGLE_CONTROL_REFERENCE:
      state = {
        ...state,
        loading: true,
      };
      break;
    case GET_SINGLE_CONTROL_REFERENCE_SUCCESS:
      state = {
        ...state,
        loading: false,
        singleControlReference: action.payload.controlReference,
      };
      break;
    case GET_SINGLE_CONTROL_REFERENCE_FAILURE:
      state = { ...state, error: action.payload, loading: false };
      break;

    case ADD_CONTROL_REFERENCE:
      state = {
        ...state,
        loading: true,
      };
      break;
    case ADD_CONTROL_REFERENCE_SUCCESS:
      state = {
        ...state,
        loading: false,
        controlReferences: action.payload.controlReferences,
      };
      break;
    case ADD_CONTROL_REFERENCE_FAILURE:
      state = { ...state, error: action.payload, loading: false };
      break;

    case DELETE_CONTROL_REFERENCE:
      state = {
        ...state,
        loading: true,
      };
      break;
    case DELETE_CONTROL_REFERENCE_SUCCESS:
      const usersAfterDeleteing = [
        ...state?.controlReferences?.filter(
          (controlReference) => getId(controlReference) !== action.payload
        ),
      ];

      state = {
        ...state,
        loading: false,
        controlReferences: usersAfterDeleteing,
      };
      break;
    case DELETE_CONTROL_REFERENCE_FAILURE:
      state = {
        ...state,
        loading: false,
        error: action.payload,
      };
      break;

    case SET_DEFAULT_CONTROL_REFERENCE_SUCCESS:
      const defaultItems = [
        ...(state?.controlReferences || [])?.map((item) =>
          getId(item) === action.payload?.id
            ? { ...item, isDefault: true }
            : { ...item, isDefault: false }
        ),
      ];

      state = {
        ...state,
        controlReferences: defaultItems,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default stores;
